import './App.css';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider } from './ThemeContext';
import Login from './components/Login';
import Register from './components/Register';
import Dashboard from './components/Dashboard';
import UserManagement from './components/UserManagement';
import StudentManagement from './components/StudentManagement';
import BatchManagement from './components/BatchManagement';
import CourseManagement from './components/CourseManagement';
import EnrollmentManagement from './components/EnrollmentManagement';
import AttendanceManagement from './components/AttendanceManagement';
import Reports from './components/Reports';
import PaymentManagement from './components/PaymentManagement';
import Invoices from './components/Invoices';
import StudentRegistration from './components/StudentRegistration';
import AdminRoute from './components/AdminRoute';
import InstructorRoute from './components/InstructorRoute';
import RoleRoute from './components/RoleRoute';
import InstructorDashboard from './components/InstructorDashboard';
import InstructorAttendanceReport from './components/InstructorAttendanceReport';
import InstructorAttendance from './components/InstructorAttendance';
import PublicRoute from './components/PublicRoute';
import TrainHubLayout from './components/TrainHubLayout';

function App() {
  return (
    <ThemeProvider>
      <Router>
        <div className="App">
          <Routes>
            {/* Public Route - Student Registration (Home Page) */}
            <Route
              path="/"
              element={<StudentRegistration />}
            />

            {/* Public Route - Login */}
            <Route
              path="/login"
              element={
                <PublicRoute>
                  <Login />
                </PublicRoute>
              }
            />

            {/* Public Route - Staff Registration */}
            <Route
              path="/register"
              element={
                <PublicRoute>
                  <Register />
                </PublicRoute>
              }
            />

            {/* Admin Routes - TrainHub layout on all pages, require auth + admin role */}
            <Route path="/dashboard" element={<AdminRoute><Dashboard /></AdminRoute>} />
            <Route path="/admin/users" element={<AdminRoute><TrainHubLayout><UserManagement /></TrainHubLayout></AdminRoute>} />
            <Route path="/admin/students" element={<AdminRoute><TrainHubLayout><StudentManagement /></TrainHubLayout></AdminRoute>} />
            <Route path="/admin/batches" element={<AdminRoute><TrainHubLayout><BatchManagement /></TrainHubLayout></AdminRoute>} />
            <Route path="/admin/courses" element={<AdminRoute><TrainHubLayout><CourseManagement /></TrainHubLayout></AdminRoute>} />
            <Route path="/admin/enrollments" element={<AdminRoute><TrainHubLayout><EnrollmentManagement /></TrainHubLayout></AdminRoute>} />
            <Route path="/admin/payments" element={<AdminRoute><TrainHubLayout><PaymentManagement /></TrainHubLayout></AdminRoute>} />
            <Route path="/admin/invoices" element={<AdminRoute><TrainHubLayout><Invoices /></TrainHubLayout></AdminRoute>} />
            <Route path="/admin/attendance" element={<AdminRoute><TrainHubLayout><AttendanceManagement /></TrainHubLayout></AdminRoute>} />
            <Route path="/admin/reports" element={<AdminRoute><TrainHubLayout><Reports /></TrainHubLayout></AdminRoute>} />

            {/* Instructor Routes */}
            <Route path="/instructor" element={<InstructorRoute><TrainHubLayout><InstructorDashboard /></TrainHubLayout></InstructorRoute>} />
            <Route path="/instructor/attendance" element={<InstructorRoute><TrainHubLayout><InstructorAttendance /></TrainHubLayout></InstructorRoute>} />
            <Route path="/instructor/reports" element={<InstructorRoute><TrainHubLayout><InstructorAttendanceReport /></TrainHubLayout></InstructorRoute>} />

            {/* Reception Routes */}
            <Route path="/reception/students" element={<RoleRoute allowedRoles={['admin', 'reception']}><TrainHubLayout><StudentManagement /></TrainHubLayout></RoleRoute>} />
            <Route path="/reception/payments" element={<RoleRoute allowedRoles={['admin', 'reception']}><TrainHubLayout><PaymentManagement /></TrainHubLayout></RoleRoute>} />
            <Route path="/reception" element={<RoleRoute allowedRoles={['admin', 'reception']}><Navigate to="/reception/students" replace /></RoleRoute>} />

            {/* Finance Routes */}
            <Route path="/finance/payments" element={<RoleRoute allowedRoles={['admin', 'finance']}><TrainHubLayout><PaymentManagement /></TrainHubLayout></RoleRoute>} />
            <Route path="/finance/invoices" element={<RoleRoute allowedRoles={['admin', 'finance']}><TrainHubLayout><Invoices /></TrainHubLayout></RoleRoute>} />
            <Route path="/finance/reports" element={<RoleRoute allowedRoles={['admin', 'finance']}><TrainHubLayout><Reports /></TrainHubLayout></RoleRoute>} />
            <Route path="/finance" element={<RoleRoute allowedRoles={['admin', 'finance']}><Navigate to="/finance/payments" replace /></RoleRoute>} />

            {/* 404 - Redirect to home */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </div>
      </Router>
    </ThemeProvider>
  );
}

export default App;
